export default "__VITE_ASSET__BiOx2KCh__"